<!-- Hero Section -->
<section class="partners-hero">
    <div class="hero-content">
        <h1 [style.viewTransitionName]="'title'">Partner With Us to Spread Hope</h1>
        <p class="hero-subtitle">
            Whether you're a healthcare facility supporting patients or an organization
            looking to give back, Wondrvoices connects your community with meaningful
            moments of encouragement.
        </p>
        <p class="hero-note">
            Join hospitals, schools, businesses, and community groups already making a difference
            in the lives of those facing cancer and serious illness.
        </p>
        <a href="spots#partner-form">
            <button class="button primary cta-btn">Become a Partner &nbsp;&rarr;</button>
        </a>
    </div>

    <div class="org-type-chips">
        <span class="chip"><span class="material-symbols-outlined">local_hospital</span> Healthcare Facility</span>
        <span class="chip"><span class="material-symbols-outlined">school</span> School / University</span>
        <span class="chip"><span class="material-symbols-outlined">apartment</span> Corporation / Business</span>
        <span class="chip"><span class="material-symbols-outlined">volunteer_activism</span> Nonprofit / Foundation</span>
        <span class="chip"><span class="material-symbols-outlined">groups</span> Community Organization</span>
        <span class="chip"><span class="material-symbols-outlined">church</span> Faith-Based Organization</span>
        <span class="chip"><span class="material-symbols-outlined">diversity_1</span> Volunteers</span>
    </div>
</section>

<!-- Partner Logos - Healthcare -->
<!-- <section class="partner-logos">
    <p class="logo-label">Healthcare Partners</p>
    <div class="marquee">
        <div class="marquee-inner">
            <img src="assets/img/spots/mayo-clinic.png" alt="Mayo Clinic" loading="lazy" />
            <img src="assets/img/spots/cleveland-clinic.png" alt="Cleveland Clinic" loading="lazy" />
            <img src="assets/img/spots/johns-hopkins.png" alt="Johns Hopkins" loading="lazy" />
            <img src="assets/img/spots/md-anderson.png" alt="MD Anderson" loading="lazy" />
            <img src="assets/img/spots/memorial-sloan.png" alt="Memorial Sloan Kettering" loading="lazy" />
            <img src="assets/img/spots/st-jude.png" alt="St. Jude" loading="lazy" />

            <img src="assets/img/spots/mayo-clinic.png" alt="Mayo Clinic" loading="lazy" />
            <img src="assets/img/spots/cleveland-clinic.png" alt="Cleveland Clinic" loading="lazy" />
            <img src="assets/img/spots/johns-hopkins.png" alt="Johns Hopkins" loading="lazy" />
            <img src="assets/img/spots/md-anderson.png" alt="MD Anderson" loading="lazy" />
            <img src="assets/img/spots/memorial-sloan.png" alt="Memorial Sloan Kettering" loading="lazy" />
            <img src="assets/img/spots/st-jude.png" alt="St. Jude" loading="lazy" />
        </div>
    </div>

    <p class="logo-label">Community Partners</p>
    <div class="marquee reverse">
        <div class="marquee-inner">
            <img src="assets/img/spots/united-way.png" alt="United Way" loading="lazy" />
            <img src="assets/img/spots/rotary.png" alt="Rotary International" loading="lazy" />
            <img src="assets/img/spots/ymca.png" alt="YMCA" loading="lazy" />
            <img src="assets/img/spots/boys-girls-club.png" alt="Boys & Girls Club" loading="lazy" />
            <img src="assets/img/spots/junior-league.png" alt="Junior League" loading="lazy" />
            <img src="assets/img/spots/lions-club.png" alt="Lions Club" loading="lazy" />
            <img src="assets/img/spots/united-way.png" alt="United Way" loading="lazy" />
            <img src="assets/img/spots/rotary.png" alt="Rotary International" loading="lazy" />
            <img src="assets/img/spots/ymca.png" alt="YMCA" loading="lazy" />
            <img src="assets/img/spots/boys-girls-club.png" alt="Boys & Girls Club" loading="lazy" />
            <img src="assets/img/spots/junior-league.png" alt="Junior League" loading="lazy" />
            <img src="assets/img/spots/lions-club.png" alt="Lions Club" loading="lazy" />
        </div>
    </div>
</section> -->

<!-- Why Partner - Benefits -->
<section class="why-partner">
    <div class="benefit-cards">
        <div class="benefit-card">
            <div class="benefit-icon heart">
                <span class="material-symbols-outlined">favorite</span>
            </div>
            <h3>Support Healing</h3>
            <p>Emotional support is a vital part of healing. Our platform helps patients feel connected during treatment with genuine human warmth, personalized messages, and the knowledge that people are rooting for them.</p>
        </div>
        <div class="benefit-card">
            <div class="benefit-icon clock">
                <span class="material-symbols-outlined">schedule</span>
            </div>
            <h3>Easy Setup</h3>
            <p>No complex training or technical requirements. Get started in minutes with our simple platform that works on any device. Your staff can facilitate access, or community members can use it independently.</p>
        </div>
        <div class="benefit-card">
            <div class="benefit-icon star">
                <span class="material-symbols-outlined">star</span>
            </div>
            <h3>Free to Start</h3>
            <p>We believe emotional support should be accessible to everyone. There's no cost to join as a partner, and we'll work with you to find the right fit for your organization's unique needs.</p>
        </div>
    </div>
</section>

<!-- Two Ways to Partner -->
<section class="two-ways">
    <h2>Two Ways to Partner</h2>
    <div class="ways-cards">
        <div class="way-card">
            <div class="way-icon receiving">
                <span class="material-symbols-outlined">favorite</span>
            </div>
            <h3>Receiving Partners</h3>
            <p>Healthcare facilities that connect patients with messages of hope and encouragement.</p>
            <ul>
                <li><span class="material-symbols-outlined">local_hospital</span> Hospitals &amp; Medical Centers</li>
                <li><span class="material-symbols-outlined">science</span> Oncology &amp; Infusion Centers</li>
                <li><span class="material-symbols-outlined">child_care</span> Pediatric Healthcare</li>
                <li><span class="material-symbols-outlined">spa</span> Hospice &amp; Palliative Care</li>
            </ul>
        </div>
        <div class="way-card">
            <div class="way-icon sending">
                <span class="material-symbols-outlined">star</span>
            </div>
            <h3>Sending Partners</h3>
            <p>Organizations that mobilize their communities to send messages of support and kindness.</p>
            <ul>
                <li><span class="material-symbols-outlined">school</span> Schools &amp; Universities</li>
                <li><span class="material-symbols-outlined">apartment</span> Corporations &amp; Businesses</li>
                <li><span class="material-symbols-outlined">groups</span> Community Organizations</li>
                <li><span class="material-symbols-outlined">church</span> Faith-Based Groups</li>
            </ul>
        </div>
    </div>
</section>

<!-- How It Works -->
<section class="how-it-works">
    <h2>How It Works</h2>
    <p class="how-subtitle">Getting started is simple. We handle the technology so you can focus on what matters most: your community.</p>

    <div class="steps">
        <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
                <h4>You Sign Up</h4>
                <p>Fill out the form below and we'll reach out within 1-2 business days. We'll learn about your organization, the people you serve, and how Wondrvoices can best support your mission.</p>
            </div>
        </div>
        <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
                <h4>Connect Your Community</h4>
                <p><strong>Receiving partners:</strong> Help patients request personalized messages of encouragement. <strong>Sending partners:</strong> Mobilize your members to create and send heartfelt support.</p>
            </div>
        </div>
        <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
                <h4>Make an Impact Together</h4>
                <p>Whether receiving or sending, your organization becomes part of a network spreading hope. Track your community's impact and celebrate the connections you've helped create.</p>
            </div>
        </div>
    </div>
</section>

<!-- Get Started Form -->
<section class="get-started" id="partner-form">
    <h2>Get Started</h2>
    <p class="form-subtitle">Tell us about your organization and we'll reach out to help you get set up.</p>

    @if (!submitted()) {
        <form
            [formGroup]="form"
            (ngSubmit)="submit()"
            class="partner-form"
            autocomplete="on">

            <div class="form-group">
                <label for="contactPerson">Your Name <span class="required">*</span></label>
                <input
                    id="contactPerson"
                    formControlName="contactPerson"
                    type="text"
                    autocomplete="name"
                    placeholder="Jane Smith" />
            </div>

            <div class="form-group">
                <label for="organizationName">Organization Name <span class="required">*</span></label>
                <input
                    id="organizationName"
                    formControlName="organizationName"
                    type="text"
                    autocomplete="organization"
                    placeholder="Sunrise Community Center" />
            </div>

            <div class="form-group">
                <label for="organizationType">Organization Type <span class="required">*</span></label>
                <select
                    id="organizationType"
                    formControlName="organizationType">
                    <option value="" disabled>Select your organization type</option>
                    @for (orgType of organizationTypes; track orgType.id) {
                        <option [value]="orgType.id">{{ orgType.label }}</option>
                    }
                </select>
            </div>

            <div class="form-group">
                <label for="email">Email Address <span class="required">*</span></label>
                <input
                    id="email"
                    formControlName="email"
                    type="email"
                    autocomplete="email"
                    placeholder="jane@organization.org" />
            </div>

            <div class="form-group">
                <label for="message">How can we help? <span class="optional">(Optional)</span></label>
                <textarea
                    id="message"
                    formControlName="message"
                    rows="4"
                    placeholder="Share your goals, the community you serve, or any questions you have..."></textarea>
            </div>

            <button
                class="button primary submit-btn"
                type="submit"
                [disabled]="form.invalid || isLoading()">
                @if (!isLoading()) {
                    Get Started
                } @else {
                    <span class="loader"></span>
                }
            </button>

            <p class="response-note">We'll respond within 1-2 business days</p>
        </form>
    } @else {
        <div class="success-message">
            <div class="success-icon">
                <span class="material-symbols-outlined">check_circle</span>
            </div>
            <h3>Thank you for your interest!</h3>
            <p>
                We've received your information and will reach out within 1-2 business days to discuss
                how we can partner together to spread hope and kindness in your community.
            </p>
        </div>
    }
</section>

@if (showSuccessDialog()) {
    <div class="success-dialog-backdrop" (click)="closeSuccessDialog()">
        <div class="success-dialog" (click)="$event.stopPropagation()">
            <div class="success-dialog__icon">
                <span class="material-symbols-outlined">celebration</span>
            </div>
            <h3>Thanks for reaching out</h3>
            <p>
                Your partnership request was sent successfully. We will review it through the existing
                Get Involved submissions inbox and follow up within 1-2 business days.
            </p>
            <button type="button" class="button primary success-dialog__button" (click)="closeSuccessDialog()">
                Close
            </button>
        </div>
    </div>
}
